import "./Categories.scss";

// Category IDs match the EZCoupons mobile app's coupon.service.ts (3-digit parent
// codes padded to 6 digits for the /api/getByCategory.php endpoint).
export const categories = [
  { title: "Restaurants",        icon: "fa fa-utensils",        id: "120000" },
  { title: "Automobile",         icon: "fa fa-car",             id: "020000" },
  { title: "Entertainment",      icon: "fa fa-film",            id: "070000" },
  { title: "Health & Beauty",    icon: "fa fa-heart",           id: "080000" },
  { title: "Home & Family",      icon: "fa fa-home",            id: "090000" },
  { title: "Clothing & Jewelry", icon: "fa fa-tshirt",          id: "040000" },
  { title: "Sports & Hobbies",   icon: "fa fa-futbol",          id: "130000" },
  { title: "Appliances",         icon: "fa fa-plug",            id: "010000" },
  { title: "Travel & Lodging",   icon: "fa fa-plane",           id: "140000" },
  { title: "Medical & Dental",   icon: "fa fa-medkit",          id: "100000" },
];

export function Categories() {
  return (
    <section class="categories">
      {categories.map((category) => (
        <a
          class="category"
          key={category.id}
          href={`/category/${category.id}`}
          aria-label={`${category.title} coupons`}
        >
          <div class="category-icon-container">
            <i class={category.icon} />
          </div>
          <h4>{category.title}</h4>
        </a>
      ))}
    </section>
  );
}
